export default "__VITE_ASSET__DyqDuxA3__"